import { render, staticRenderFns } from "./librarybooks.vue?vue&type=template&id=6dde51a8&"
import script from "./librarybooks.vue?vue&type=script&lang=js&"
export * from "./librarybooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports